import { AlertTriangle, CreditCard, X } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PaymentFailureBannerProps {
  invoiceUrl?: string;
  onDismiss?: () => void;
}

export default function PaymentFailureBanner({ invoiceUrl, onDismiss }: PaymentFailureBannerProps) {
  return (
    <div className="bg-red-50 dark:bg-red-950/30 border-b border-red-200 dark:border-red-900/50 px-4 py-3 transition-all duration-300">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm relative">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-red-600 dark:text-red-400 shrink-0" />
          <span className="font-semibold text-red-900 dark:text-red-200">Payment Failed</span>
        </div>
        <span className="hidden sm:inline text-red-300 dark:text-red-800">|</span>
        <span className="text-red-700 dark:text-red-300 text-center sm:text-left">
          Your subscription payment requires attention
        </span>
        
        <div className="flex items-center gap-2 mt-2 sm:mt-0 sm:ml-4">
          {invoiceUrl ? (
            <a
              href={invoiceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs font-medium bg-white dark:bg-red-900/40 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 px-3 py-1.5 rounded-full hover:bg-red-50 dark:hover:bg-red-900/60 transition-colors shadow-sm"
            >
              <CreditCard className="h-3.5 w-3.5" />
              Update Payment
            </a>
          ) : (
            <Link
              to="/account?tab=billing"
              className="inline-flex items-center gap-1.5 text-xs font-medium bg-white dark:bg-red-900/40 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 px-3 py-1.5 rounded-full hover:bg-red-50 dark:hover:bg-red-900/60 transition-colors shadow-sm"
            >
              <CreditCard className="h-3.5 w-3.5" />
              Go to Billing
            </Link>
          )}
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1 rounded-full hover:bg-red-100 dark:hover:bg-red-900/40 text-red-600 dark:text-red-400 transition-colors"
              title="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
